import React, { useState, useEffect } from "react";
import { Layout, Select } from 'antd';
import { connect } from 'react-redux';
import { SIDE_NAV_WIDTH, SIDE_NAV_DARK, NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import { Scrollbars } from 'react-custom-scrollbars';
import MenuContent from './MenuContent'
import CustomSelect from "./CustomSelect";
import { useTranslation } from "react-i18next";

const { Sider } = Layout;



export const SideNav = ({ navCollapsed, sideNavTheme, routeInfo, hideGroupTitle, localization = true, selectedValue, handleChange }) => {
  const props = { sideNavTheme, routeInfo, hideGroupTitle, localization }
  // const [selectedValue, setSelectedValue] = useState("");
  const [menuListData, setMenuListData] = useState([]);

  const { t, i18n } = useTranslation();
  useEffect(() => {
    const storedMenuListUpper = JSON.parse(localStorage.getItem("LEFT_MENU_LIST") || "[]") || [];
    const storedMenuListLower = JSON.parse(localStorage.getItem("leftMenuList") || "[]") || [];
    const storedMenuList = storedMenuListUpper.length > 0 ? storedMenuListUpper : storedMenuListLower;



    setMenuListData(storedMenuList);
    if (storedMenuList.length > 0) {
      handleChange(storedMenuList[0].appName, storedMenuList);
    }
  }, []);

  // const handleChange = (value) => {
  //   setSelectedValue(value);
  //   const selectedApp = menuListData.find((app) => app.appName === value);
  //   if (selectedApp) {
  //     localStorage.setItem('selectedApp', JSON.stringify(selectedApp));
  //   }
  // };

  // useEffect(() => {
  //   const storedSelectedApp = JSON.parse(localStorage.getItem('selectedApp'));
  //   if (storedSelectedApp != null) {

  //     setSelectedValue(storedSelectedApp.appName);
  //   }
  // }, []);

  return (
    <Sider
      className={`side-nav ${sideNavTheme === SIDE_NAV_DARK ? 'side-nav-dark' : ''}`}
      width={SIDE_NAV_WIDTH}
      collapsed={navCollapsed}
    >
      <Scrollbars autoHide>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            padding: "8px",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            overflowX:"hidden"
          }}
        >
          {/* Üst kısım (scrollable içerik) */}
          <div style={{ flex: 1, overflow: "auto" , overflowX:"hidden"}}  >
            {(!menuListData.length || menuListData.length === 1) ? null : (
              <CustomSelect
                menuListData={menuListData}
                selectedValue={selectedValue}
                handleChange={(value) => handleChange(value, menuListData)}
              />
            )}
            <MenuContent type={NAV_TYPE_SIDE} selectedValue={selectedValue} {...props} />
          </div>

          {/* Alt kısım (logo) */}
          <div
            className="mt-3"
            style={{
              width: "100%",
              textAlign: "center",
              padding: "10px",
              borderTop: "1px solid rgba(255, 255, 255, 0.1)",
              overflowX:"hidden"
            }}
          >
            {i18n.language === "tr" ? (
              <img
                src="/img/logos/logo1.png"
                alt="Alt Logo"
                style={{ width: "70%", maxWidth: "90px" }}
              />
            ) : (
              <img
                src="/img/logos/logo2.png"
                alt="Alt Logo"
                style={{ width: "70%", maxWidth: "90px" }}
              />
            )}
          </div>
        </div>



      </Scrollbars>

    </Sider>
  )
}

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, sideNavTheme } = theme;
  return { navCollapsed, sideNavTheme }
};

export default connect(mapStateToProps)(SideNav);
